import { classNamesFunction, Stack, styled, Text } from '@fluentui/react';
import { TopMenu } from '../TopMenu';

const getStyles = ({ theme }) => {
  return {
    root: {},
    sidebar: {},
    contentWrapper: {
    }
  };
};

const getClassNames = classNamesFunction();
//TODO change this to typescript

function MasterLayoutComponent({ children, theme, styles }) {
  const classNames = getClassNames(styles, { theme });
  return (
    <>
      <TopMenu />
      <Stack horizontal className={classNames.root}>
        {/* <Stack.Item className={classNames.sidebar} styles={{ root: { flexBasis: '0' } }}>
            <Sidebar />
          </Stack.Item> */}

        {/* https://stackoverflow.com/questions/31967019/max-width-doesnt-work-in-flexbox */}
        <Stack.Item grow styles={{ root: { flexBasis: '0', overflow: 'hidden' } }}>
          <Stack className={classNames.contentWrapper}>
            {children}
          </Stack>
        </Stack.Item>
      </Stack>
      <Text
        variant='xSmall'
        styles={{
          root: {
            color: 'gray',
            marginLeft: 'auto',
            marginRight: 'auto',
            display: 'block',
            textAlign: 'center',
            marginTop: '6px'
          }
        }}
      >
        Version {process.env.REACT_APP_VERSION} / CRM {process.env.REACT_APP_CRM} / PORTAL {process.env.REACT_APP_PORTAL}
      </Text>
    </>
  );
}

export const MasterLayout = styled(MasterLayoutComponent, getStyles);
